import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    isOpen: false,
    content: null,
    closeable: null
};

const modalSlice = createSlice({
    name: 'modal',
    initialState,
    reducers: {
        openModal: (state, action) => {
            state.isOpen = true;
            state.content = action.payload.content;
            state.closeable = action.payload.closeable ? true : null;
        },
        closeModal: (state) => {
            state.isOpen = false;
            state.content = null;
        }
    }
});

export const { openModal, closeModal } = modalSlice.actions;
export default modalSlice.reducer;